import { MEASUREMENT_TYPES } from "../../../../../config/enums/MeasurementTypes";
import { PackagingType } from "../../../../../config/enums/PackagingType.enum";
import { UseMutateFunction } from "@tanstack/react-query";
import { Control } from "react-hook-form";
import { PackagingLevelMeta } from "./packagingLevel.config";

export type PackagingGate = "farm-gate" | "process-gate";

export const PACKAGING_GATE = {
  FARM: "farm-gate",
  PROCESS: "process-gate"
} as const;

export interface PackagingMutationHandlers {
  mutate: UseMutateFunction<any, unknown, any, unknown>;
  isLoading: boolean;
}

export interface PackagingMutations {
  create: PackagingMutationHandlers;
  update: PackagingMutationHandlers;
  delete: PackagingMutationHandlers;
  isLoading: boolean;
}

export interface PackagingLevelProps {
  gate: PackagingGate;
  gateId: string;
  mutations: PackagingMutations;
  packagingData: any[];
  refetchData: (...args: any[]) => any;
  packagingType: PackagingType;
  packagingId: string | null;
  savePackingNodeData: (id: string, name?: string) => void;
  packagingTypeData: any[];
  totalWeightOfItem?: number;
  unitSizes: number;
  weightUnit?: MEASUREMENT_TYPES;
  palletLength?: number;
  palletWidth?: number;
  updatePackingDetails: (value: unknown, type: string) => void;
  changeUnitsType: string;
  unitSizeWeightUnit?: MEASUREMENT_TYPES;
  setUnitSizeWeightUnit?: (value: MEASUREMENT_TYPES) => void;
  setIsSaveBtnClicked: (value: boolean) => void;
  isSaveBtnClicked: boolean;
  setClickedPackagingUnit: (value: string) => void;
  clickedPackagingUnit: string;
  packagingName?: string;
  lockStatus?: boolean;
  onPackagingSave?: (packagingId: string) => void;
}

export interface PackagingLevelSectionProps {
  title: string;
  badge?: string;
  expanded: boolean;
  disabled: boolean;
  onToggle: () => void;
}

export interface PackagingLevelUnitSectionProps {
  packagingType: PackagingType;
  fieldName: string;
  levelMeta: PackagingLevelMeta;
  control: Control<any>;
  unitFieldsLocked: boolean;
  showMaterialsSection: boolean;
  unitGateMessage: string;
  lockStatus: boolean;
  onUnitEdit: () => void;
  saveUnitValue: (value: number) => void;
  saveTransportUnitValue: (width: number, length: number, unitValue: number) => void;
  enableOtherUnitSaving: boolean;
  saveTransportUnitDataValidation: boolean;
  canSavePackagingUnit: boolean;
  canSaveTransportUnit: boolean;
  palletUnitNumeric: number;
  palletWidthData: number;
  palletLengthData: number;
  unitSizes: number;
  palletLength?: number;
  palletWidth?: number;
  weightUnit: MEASUREMENT_TYPES;
  unitSizeWeightUnit?: MEASUREMENT_TYPES;
  onUnitSizeWeightUnitChange?: (value: MEASUREMENT_TYPES) => void;
  totalWeightLabel: string;
  displayTotalWeight: number;
  totalWeightUnit?: string;
}

export interface PackagingDeleteModalProps {
  visible: boolean;
  onClose: () => void;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  subTitle: string;
}
